const IDLE_MS = 60 * 1000;
const MAX_STEP_MS = 250;

// Measures how long a published level is actively played, so levels can be
// ranked by engagement. Time stops counting a minute after the last input.
export class LevelSession {
    constructor(send, now = () => performance.now()) {
        this.send = send;
        this.now = now;
        this.levelId = null;
        this.lastInteraction = -Infinity;
        this.lastUpdate = now();
    }

    listen(document, window) {
        const interact = event => {
            if (event.isTrusted) this.interact();
        };
        document.addEventListener('pointerdown', interact, {capture: true});
        document.addEventListener('keydown', interact, {capture: true});
        // The last moment a closing tab or backgrounded mobile app can still send.
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.flush();
        });
        window.addEventListener('pagehide', () => this.flush());
    }

    interact() {
        this.lastInteraction = this.now();
    }

    begin(levelId) {
        if (levelId === this.levelId) {
            this.retries++;
            return;
        }
        this.end();
        this.levelId = levelId;
        this.ms = 0;
        this.retries = 0;
        this.finished = false;
        this.reported = false;
    }

    retry() {
        if (this.levelId) this.retries++;
    }

    finish() {
        if (this.levelId) this.finished = true;
    }

    update(active) {
        const now = this.now();
        const step = Math.min(now - this.lastUpdate, MAX_STEP_MS);
        this.lastUpdate = now;
        if (this.levelId && active && now - this.lastInteraction < IDLE_MS) this.ms += step;
    }

    flush() {
        if (!this.levelId) return;
        const seconds = Math.floor(this.ms / 1000);
        if (this.reported && !seconds && !this.retries && !this.finished) return;
        this.ms -= seconds * 1000;
        this.send(this.levelId, {seconds, retries: this.retries, finished: this.finished, resumed: this.reported});
        this.reported = true;
        this.retries = 0;
        this.finished = false;
    }

    end() {
        this.flush();
        this.levelId = null;
    }
}
